// extracted by mini-css-extract-plugin
export default {"root":"ManufacturerSelect_root__H5UKN","container":"ManufacturerSelect_container__RY5Xb"};